import trimText from '@helpers/trim-text';
import type { ApiMessage } from '@interfaces/message';

export const TRUNCATED_SUMMARY_LENGTH = 200;

export function getMessageSummaryText(message: ApiMessage, truncateLength = TRUNCATED_SUMMARY_LENGTH) {
  // Can be enhanced to generate message summaries for media messages

  if (!message.body) {
    return '';
  }

  return trimText(message.body, truncateLength);
}
